module.exports = __webpack_public_path__ + "img/support.0ae33219.svg";